import { render } from '@react-pdf/renderer';
import { Select, Tooltip } from 'antd';
import Cookies from 'js-cookie';
import { formatNumberWithComma } from './formula/CodeWindow';
import { decryptData } from '@/components/reusable/crypto/Cipher';

const userData = decryptData(localStorage.getItem('userData'));

export const companyListTableHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
  },
  {
    title: 'Company Name',
    dataIndex: 'name',
    key: 'name',
    align: 'left',
  },
  {
    title: 'Address',
    key: 'address',
    dataIndex: 'address',
    align: 'left',
  },

  // {
  //   title: 'Fiscal Year Start',
  //   key: 'financialStart',
  //   dataIndex: 'financialStart',
  //   align: 'center',
  // },
  // {
  //   title: 'Fiscal Year End',
  //   key: 'FinancialEnd',
  //   dataIndex: 'financialEnd',
  //   align: 'center',
  // },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 80,
  },
];

export const userCompanyListMappingHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
  },
  {
    title: 'Company',
    dataIndex: 'company',
    key: 'company',
    align: 'center',
  },
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
    align: 'center',
  },

  {
    title: 'Username',
    dataIndex: 'username',
    key: 'username',
    align: 'center',
  },

  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
  },
];

export const companyMenuMappingHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
  },
  {
    title: 'Company Name',
    dataIndex: 'company',
    key: 'company',
    align: 'center',
  },

  {
    title: 'Menu',
    dataIndex: 'menu',
    key: 'menu',
    align: 'center',
    ellipsis: true,
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
  },
];
export const branchListTableHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
  },
  {
    title: 'Company',
    dataIndex: 'company',
    key: 'company',
    align: 'left',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
  },
  {
    title: 'Branch',
    dataIndex: 'name',
    key: 'name',
    align: 'left',
  },
  {
    title: 'Address',
    key: 'address',
    dataIndex: 'address',
    align: 'left',
  },
  {
    title: 'Calculation Type',
    key: 'calculationType',
    dataIndex: 'calculationType',
    align: 'left',
  },
  // {
  //   title: 'Show Image',
  //   key: 'showImage',
  //   dataIndex: 'showImage',
  //   align: 'center',
  // },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];
export const financialYearListTableHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
  },
  {
    title: 'Company',
    dataIndex: 'companyId',
    key: 'company',
    align: 'left',
  },
  {
    title: 'Branch',
    dataIndex: 'branchId',
    key: 'branch',
    align: 'left',
  },
  {
    title: 'Start Date',
    key: 'startDate',
    dataIndex: 'startDate',
    align: 'left',
  },
  {
    title: 'End Date',
    key: 'endDate',
    dataIndex: 'endDate',
    align: 'left',
  },
  {
    title: 'Active Status',
    key: 'isActive',
    dataIndex: 'isActive',
    align: 'center',
    width: 150,
  },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 100,
  },
];

export const accountGroupTableHeader = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    // filters: [
    //   {
    //     text: 'industries',
    //     value: 'industries',
    //   },
    //   {
    //     text: 'factory',
    //     value: 'factory',
    //   },
    // ],
    align: 'center',
  },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: '10%',
  },
];
export const ledgerTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    render: (_, __, index) => index + 1,
    width: 50,
  },
  {
    title: 'Ledger Name',
    dataIndex: 'name',
    key: 'name',
    align: 'left',
    width: '35%',
  },
  {
    title: 'Group',
    dataIndex: 'groupName',
    key: 'groupName',
    align: 'left',
    // width: '20%',
  },
  {
    title: 'Category',
    dataIndex: 'ledgerCategory',
    key: 'ledgerCategory',
    align: 'left',
    // width: '15%',
  },
  {
    title: 'Metal',
    align: 'center',
    children: [
      {
        title: 'Dr',
        key: 'metalBalanceDr',
        dataIndex: 'metalBalanceDr',
        align: 'right',
        width: 60,
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.metalBalanceDr - b.metalBalanceDr,
      },
      {
        title: 'Cr',
        key: 'metalBalanceCr',
        dataIndex: 'metalBalanceCr',
        align: 'right',
        width: 60,
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.metalBalanceCr - b.metalBalanceCr,
      },
    ],
  },

  {
    title: 'Amount',
    align: 'center',
    children: [
      {
        title: 'Dr',
        key: 'openingBalanceDr',
        dataIndex: 'openingBalanceDr',
        align: 'right',
        width: 70,
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.openingBalanceDr - b.openingBalanceDr,
      },
      {
        title: 'Cr',
        key: 'openingBalanceCr',
        dataIndex: 'openingBalanceCr',
        align: 'right',
        width: 70,
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.openingBalanceCr - b.openingBalanceCr,
      },
    ],
  },
];
export const openingBalanceTableHeader = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    // filters: [
    //   {
    //     text: 'industries',
    //     value: 'industries',
    //   },
    //   {
    //     text: 'factory',
    //     value: 'factory',
    //   },
    // ],
    align: 'center',
  },
  {
    title: 'Group',
    key: 'group',
    filters: [
      {
        text: 'A',
        value: 'A',
      },
      {
        text: 'B',
        value: 'B',
      },
    ],
    dataIndex: 'group',
    align: 'center',
  },
  {
    title: 'Amount',
    align: 'center',
    children: [
      {
        title: 'DR',
        key: 'amountdr',
        dataIndex: 'amountdr',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.balance - b.balance,
      },
      {
        title: 'CR',
        key: 'amountcr',
        dataIndex: 'amountcr',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.balance - b.balance,
      },
    ],
  },

  {
    title: 'Metal',
    align: 'center',
    children: [
      {
        title: 'DR',
        key: 'metaldr',
        dataIndex: 'metaldr',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.balance - b.balance,
      },
      {
        title: 'CR',
        key: 'metalcr',
        dataIndex: 'metalcr',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.balance - b.balance,
      },
    ],
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: '10%',
  },
];
export const inventoryGroupsTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    render: (_, __, index) => index + 1,
    width: 50,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    // filters: [
    //   {
    //     text: 'industries',
    //     value: 'industries',
    //   },
    //   {
    //     text: 'factory',
    //     value: 'factory',
    //   },
    // ],
  },
  // {
  //   title: 'Group',
  //   dataIndex: 'groupName',
  //   key: 'groupName',
  //   // filters: [
  //   //   {
  //   //     text: 'industries',
  //   //     value: 'industries',
  //   //   },
  //   //   {
  //   //     text: 'factory',
  //   //     value: 'factory',
  //   //   },
  //   // ],
  // },
];

export const inventoryItemTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    render: (_, __, index) => index + 1,
    width: 50,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    // filters: [
    //   {
    //     text: 'industries',
    //     value: 'industries',
    //   },
    //   {
    //     text: 'factory',
    //     value: 'factory',
    //   },
    // ],
    align: 'left',
    width: '50%',
  },
  {
    title: 'Type',
    key: 'typeName',
    dataIndex: 'typeName',
    align: 'left',
  },
  {
    title: 'Prefix',
    key: 'barCodePrefix',
    dataIndex: 'barCodePrefix',
    align: 'left',
  },

  {
    title: 'Barcode',
    key: 'barCode',
    dataIndex: 'barCode',
    align: 'left',
  },
];
export const branchListsTableHeader = [
  {
    title: 'Branch Name',
    dataIndex: 'branchName',
    key: 'branchName',
    align: 'center',
  },
  {
    title: 'Address',
    dataIndex: 'address',
    key: 'address',
    align: 'center',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
  },
];
export const inventoryGroupTableHeader = [
  {
    title: 'Company Name',
    dataIndex: 'companyName',
    key: 'companyName',
    align: 'center',
  },
  {
    title: 'Address',
    dataIndex: 'companyAddress',
    key: 'companyAddress',
    align: 'center',
  },
  {
    title: 'Financial Start Year',
    dataIndex: 'companyFinancialYearStart',
    key: 'companyFinancialYearStart',
    align: 'center',
  },
  {
    title: 'Financial End Year',
    dataIndex: 'companyFinancialYearEnd',
    key: 'companyFinancialYearEnd',
    align: 'center',
  },
];
export const storeTableHeader = [
  {
    title: 'Company Name',
    dataIndex: 'name',
    key: 'name',
    align: 'start',
  },
  {
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    align: 'center',
  },
];

export const storeListTableHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
    render: (_, __, i) => i + 1,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    align: 'left',
  },
  {
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    align: 'center',
  },
  {
    title: 'Company',
    dataIndex: 'companyName',
    key: 'companyName',
    align: 'center',
  },
  {
    title: 'Branch',
    dataIndex: 'branchName',
    key: 'branchName',
    align: 'center',
  },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];

export const CenterElement = (props) => {
  const { children } = props;
  return <div className="tw-flex tw-justify-center">{children}</div>;
};

export const SALES_ORDER_COLUMNS_NEW = [
  {
    title: 'S.N.',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: 27,
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'left',
    width: '170px',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
    width: '80px',
    render: (text) => text,
  },

  {
    title: <CenterElement>Purity</CenterElement>,
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '40px',
  },
  {
    title: <CenterElement>Gwt.</CenterElement>,
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>Dia. Wt.</CenterElement>,
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>St. Wt.</CenterElement>,
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </CenterElement>
    ),
    dataIndex: 'nwt',
    key: 'nwt',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </CenterElement>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: '68px',
  },
  {
    title: <CenterElement>P. Wt.</CenterElement>,
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: '65px',
  },

  {
    title: <CenterElement>Wstg Wt.</CenterElement>,
    dataIndex: 'wastage',
    key: 'wastage',
    align: 'right',
    width: '72px',
  },

  {
    title: <CenterElement>Nt. with Wstg</CenterElement>,
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'right',
    width: '80px',
  },
  {
    title: <CenterElement>Making Amt.</CenterElement>,
    dataIndex: 'amount',
    key: 'amount',
    align: 'right',
    width: '70px',
  },
  // {
  //   title: <CenterElement>Rate</CenterElement>,
  //   dataIndex: 'rate',
  //   key: 'rate',
  //   align: 'right',
  //   width: '70px',
  // },
  {
    title: <CenterElement>Rate</CenterElement>,
    dataIndex: 'ratePerPurity',
    key: 'ratePerPurity',
    align: 'right',
    width: '70px',
  },

  {
    title: <CenterElement>Sub Total</CenterElement>,
    dataIndex: 'subTotal',
    key: 'subTotal',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  {
    title: <CenterElement>Dis. Amt.</CenterElement>,
    dataIndex: 'discountAmount',
    key: 'discountAmount',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },
  {
    title: <CenterElement>Taxable Amt.</CenterElement>,
    dataIndex: 'taxableAmount',
    key: 'taxableAmount',
    align: 'right',
    width: '75px',
  },

  ...(userData?.isTaxApplicable
    ? [
        {
          title: <CenterElement>Tax Amt.</CenterElement>,
          dataIndex: 'taxAmount',
          key: 'taxAmount',
          align: 'right',
          width: '75px',
        },
      ]
    : []),

  ...(userData?.isVatApplicable
    ? [
        {
          title: <CenterElement>VAT Amt.</CenterElement>,
          dataIndex: 'vatAmount',
          key: 'vatAmount',
          align: 'right',
          width: '75px',
        },
      ]
    : []),

  // {
  //   title: <CenterElement>VAT Amt.</CenterElement>,
  //   dataIndex: 'vatAmount',
  //   key: 'vatAmount',
  //   align: 'right',
  //   width: '75px', // Set a small width to test wrapping
  // },

  {
    title: <CenterElement>Net Amt.</CenterElement>,
    dataIndex: 'netAmountWithTax',
    key: 'netAmountWithTax',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },
  {
    title: <CenterElement>Action</CenterElement>,
    key: 'action',
    dataIndex: 'action',
    width: '20px',
    fixed: 'right',
    align: 'center',
  },
];

export const TransactionPurchaseTableHeaderOld = [
  {
    title: 'S.N.',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: 27,
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'left',
    width: '170px',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
    width: '80px',
    render: (text) => text,
  },

  {
    title: <CenterElement>Purity</CenterElement>,
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '40px',
  },
  {
    title: <CenterElement>Gwt.</CenterElement>,
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>Dia. Wt.</CenterElement>,
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>St. Wt.</CenterElement>,
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </CenterElement>
    ),
    dataIndex: 'nwt',
    key: 'nwt',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </CenterElement>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: '68px',
  },
  {
    title: <CenterElement>P. Wt.</CenterElement>,
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: '65px',
  },

  {
    title: <CenterElement>Wstg Wt.</CenterElement>,
    dataIndex: 'wastage',
    key: 'wastage',
    align: 'right',
    width: '72px',
  },

  {
    title: <CenterElement>Nt. with Wstg</CenterElement>,
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'right',
    width: '80px',
  },
  {
    title: <CenterElement>Making Amt.</CenterElement>,
    dataIndex: 'amount',
    key: 'amount',
    align: 'right',
    width: '70px',
  },
  // {
  //   // title: `\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\Rate`,
  //   title: <CenterElement>Rate</CenterElement>,
  //   dataIndex: 'rate',
  //   key: 'rate',
  //   align: 'right',
  //   width: '70px',
  // },
  {
    // title: `\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\Rate`,
    title: <CenterElement>Rate</CenterElement>,
    dataIndex: 'ratePerPurity',
    key: 'ratePerPurity',
    align: 'right',
    width: '70px',
  },

  {
    title: <CenterElement>Net Amt.</CenterElement>,
    dataIndex: 'netAmount',
    key: 'netAmount',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  // {
  //   title: <CenterElement>VAT Amt.</CenterElement>,
  //   dataIndex: 'vatAmount',
  //   key: 'vatAmount',
  //   align: 'right',
  //   width: '75px', // Set a small width to test wrapping
  // },

  // {
  //   title: <CenterElement>Net Amt.</CenterElement>,
  //   dataIndex: 'netAmountWithTax',
  //   key: 'netAmountWithTax',
  //   align: 'right',
  //   width: '75px', // Set a small width to test wrapping
  // },

  {
    title: <CenterElement>Action</CenterElement>,
    key: 'action',
    dataIndex: 'action',
    width: '20px',
    fixed: 'right',
    align: 'center',
  },
];

export const ReceiveTableColumnsForSales = [
  {
    title: 'S.N.',
    dataIndex: 'sn',
    key: 'SN',
    align: 'center',
    width: 27,
  },
  {
    title: 'Item',
    dataIndex: 'itemName',
    key: 'item',
    align: 'left',
    width: '170px',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
    width: '80px',
    render: (text) => text,
  },

  {
    title: <CenterElement>Purity</CenterElement>,
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '40px',
  },
  {
    title: <CenterElement>Gwt.</CenterElement>,
    dataIndex: 'grossWeight',
    key: 'grossWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>Dia. Wt.</CenterElement>,
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>St. Wt.</CenterElement>,
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </CenterElement>
    ),
    dataIndex: 'netWeight',
    key: 'netWeight',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </CenterElement>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: '68px',
  },
  {
    title: <CenterElement>Pure Weight</CenterElement>,
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: '65px',
  },

  {
    title: <CenterElement>Wstg Wt.</CenterElement>,
    dataIndex: 'wastageWeight',
    key: 'wastageWeight',
    align: 'right',
    width: '72px',
  },

  {
    title: <CenterElement>Nt. with Wstg</CenterElement>,
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'right',
    width: '80px',
  },
  {
    title: <CenterElement>Making Amt.</CenterElement>,
    dataIndex: 'makingAmount',
    key: 'makingAmount',
    align: 'right',
    width: '70px',
  },
  {
    // title: `\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\Rate`,
    title: <CenterElement>Rate</CenterElement>,
    dataIndex: 'rate',
    key: 'rate',
    align: 'right',
    width: '70px',
  },

  // {
  //   title: <CenterElement>Net Amt.</CenterElement>,
  //   dataIndex: 'netAmount',
  //   key: 'netAmount',
  //   align: 'right',
  //   width: '75px', // Set a small width to test wrapping
  // },
];

export const TransactionPurchaseTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: 27,
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'left',
    width: '170px',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
    width: '80px',
    render: (text) => text,
  },

  {
    title: <CenterElement>Purity</CenterElement>,
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '40px',
  },
  {
    title: <CenterElement>Gwt.</CenterElement>,
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>Dia. Wt.</CenterElement>,
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>St. Wt.</CenterElement>,
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </CenterElement>
    ),
    dataIndex: 'nwt',
    key: 'nwt',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </CenterElement>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: '68px',
  },
  {
    title: <CenterElement>P. Wt.</CenterElement>,
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: '65px',
  },

  {
    title: <CenterElement>Wstg Wt.</CenterElement>,
    dataIndex: 'wastage',
    key: 'wastage',
    align: 'right',
    width: '72px',
  },

  {
    title: <CenterElement>Nt. with Wstg</CenterElement>,
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'right',
    width: '80px',
  },
  {
    title: <CenterElement>Making Amt.</CenterElement>,
    dataIndex: 'amount',
    key: 'amount',
    align: 'right',
    width: '70px',
  },
  {
    // title: `\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\Rate`,
    title: <CenterElement>Rate</CenterElement>,
    dataIndex: 'rate',
    key: 'rate',
    align: 'right',
    width: '70px',
  },

  // {
  //   title: <CenterElement>Net Amt.</CenterElement>,
  //   dataIndex: 'netAmount',
  //   key: 'netAmount',
  //   align: 'right',
  //   width: '75px', // Set a small width to test wrapping
  // },

  {
    title: <CenterElement>VAT Amt.</CenterElement>,
    dataIndex: 'vatAmount',
    key: 'vatAmount',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  {
    title: <CenterElement>Net Amt.</CenterElement>,
    dataIndex: 'netAmountWithTax',
    key: 'netAmountWithTax',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  {
    title: <CenterElement>Action</CenterElement>,
    key: 'action',
    dataIndex: 'action',
    width: '20px',
    fixed: 'right',
    align: 'center',
  },
];

export const TransactionPurchaseTableHeaderNewLatest = [
  {
    title: 'S.N.',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: 27,
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'left',
    width: '170px',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
    width: '80px',
    render: (text) => text,
  },

  {
    title: <CenterElement>Purity</CenterElement>,
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '40px',
  },
  {
    title: <CenterElement>Gwt.</CenterElement>,
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>Dia. Wt.</CenterElement>,
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>St. Wt.</CenterElement>,
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </CenterElement>
    ),
    dataIndex: 'nwt',
    key: 'nwt',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </CenterElement>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: '68px',
  },
  {
    title: <CenterElement>P. Wt.</CenterElement>,
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: '65px',
  },

  {
    title: <CenterElement>Wstg Wt.</CenterElement>,
    dataIndex: 'wastage',
    key: 'wastage',
    align: 'right',
    width: '72px',
  },

  {
    title: <CenterElement>Nt. with Wstg</CenterElement>,
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'right',
    width: '80px',
  },
  {
    title: <CenterElement>Making Amt.</CenterElement>,
    dataIndex: 'amount',
    key: 'amount',
    align: 'right',
    width: '70px',
  },
  // {
  //   // title: `\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\Rate`,
  //   title: <CenterElement>Rate</CenterElement>,
  //   dataIndex: 'rate',
  //   key: 'rate',
  //   align: 'right',
  //   width: '70px',
  // },
  {
    // title: `\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\Rate`,
    title: <CenterElement>Rate</CenterElement>,
    dataIndex: 'ratePerPurity',
    key: 'ratePerPurity',
    align: 'right',
    width: '70px',
  },

  // {
  //   title: <CenterElement>Net Amt.</CenterElement>,
  //   dataIndex: 'netAmount',
  //   key: 'netAmount',
  //   align: 'right',
  //   width: '75px', // Set a small width to test wrapping
  // },

  {
    title: <CenterElement>Sub Total</CenterElement>,
    dataIndex: 'netAmount',
    key: 'netAmount',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  {
    title: <CenterElement>Dis. Amt.</CenterElement>,
    dataIndex: 'discountAmount',
    key: 'discountAmount',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  ...(userData?.isVatApplicable
    ? [
        {
          title: <CenterElement>VAT Amt.</CenterElement>,
          dataIndex: 'vatAmount',
          key: 'vatAmount',
          align: 'right',
          width: '75px',
        },
      ]
    : []),

  // {
  //   title: <CenterElement>VAT Amt.</CenterElement>,
  //   dataIndex: 'vatAmount',
  //   key: 'vatAmount',
  //   align: 'right',
  //   width: '75px',
  // },

  {
    title: <CenterElement>Net Amt.</CenterElement>,
    dataIndex: 'netAmountWithTax',
    key: 'netAmountWithTax',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  {
    title: <CenterElement>Action</CenterElement>,
    key: 'action',
    dataIndex: 'action',
    width: '20px',
    fixed: 'right',
    align: 'center',
  },
];

//new column
export const TransactionPurchaseTableHeaderNew = [
  {
    title: 'S.N.',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: 27,
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'left',
    width: '170px',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
    width: '80px',
    render: (text) => text,
  },

  {
    title: <CenterElement>Purity</CenterElement>,
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '40px',
  },
  {
    title: <CenterElement>Gwt.</CenterElement>,
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>Dia. Wt.</CenterElement>,
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>St. Wt.</CenterElement>,
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </CenterElement>
    ),
    dataIndex: 'nwt',
    key: 'nwt',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </CenterElement>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: '68px',
  },
  {
    title: <CenterElement>P. Wt.</CenterElement>,
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: '65px',
  },

  {
    title: <CenterElement>Wstg Wt.</CenterElement>,
    dataIndex: 'wastage',
    key: 'wastage',
    align: 'right',
    width: '72px',
  },

  {
    title: <CenterElement>Nt. with Wstg</CenterElement>,
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'right',
    width: '80px',
  },
  {
    title: <CenterElement>Making Amt.</CenterElement>,
    dataIndex: 'amount',
    key: 'amount',
    align: 'right',
    width: '70px',
  },
  // {
  //   title: <CenterElement>Rate</CenterElement>,
  //   dataIndex: 'rate',
  //   key: 'rate',
  //   align: 'right',
  //   width: '70px',
  // },
  {
    title: <CenterElement>Rate</CenterElement>,
    dataIndex: 'ratePerPurity',
    key: 'ratePerPurity',
    align: 'right',
    width: '70px',
  },

  {
    title: <CenterElement>Sub Total</CenterElement>,
    dataIndex: 'netAmount',
    key: 'netAmount',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  {
    title: <CenterElement>Dis. Amt.</CenterElement>,
    dataIndex: 'discountAmount',
    key: 'discountAmount',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },
  // {
  //   title: <CenterElement>Taxable Amt.</CenterElement>,
  //   dataIndex: 'taxableAmount',
  //   key: 'taxableAmount',
  //   align: 'right',
  //   width: '75px',
  // },

  // ...(userData?.isLuxuryTaxApplicable
  //   ? [
  //       {
  //         title: <CenterElement>Tax Amt.</CenterElement>,
  //         dataIndex: 'taxAmount',
  //         key: 'taxAmount',
  //         align: 'right',
  //         width: '75px',
  //       },
  //     ]
  //   : []),

  // {
  //   title: <CenterElement>Tax Amt.</CenterElement>,
  //   dataIndex: 'taxAmount',
  //   key: 'taxAmount',
  //   align: 'right',
  //   width: '75px', // Set a small width to test wrapping
  // },

  // ...(userData?.isVatApplicable
    // ? [
        {
          title: <CenterElement>VAT Amt.</CenterElement>,
          dataIndex: 'vatAmount',
          key: 'vatAmount',
          align: 'right',
          width: '75px',
        },
      // ]
    // : []),

  // {
  //   title: <CenterElement>VAT Amt.</CenterElement>,
  //   dataIndex: 'vatAmount',
  //   key: 'vatAmount',
  //   align: 'right',
  //   width: '75px', // Set a small width to test wrapping
  // },

  {
    title: <CenterElement>Net Amt.</CenterElement>,
    dataIndex: 'netAmountWithTax',
    key: 'netAmountWithTax',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  {
    title: <CenterElement>Action</CenterElement>,
    key: 'action',
    dataIndex: 'action',
    width: '20px',
    fixed: 'right',
    align: 'center',
  },
];

export const SalesTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: 27,
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'left',
    width: '170px',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
    width: '80px',
    render: (text) => text,
  },

  {
    title: <CenterElement>Purity</CenterElement>,
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '40px',
  },
  {
    title: <CenterElement>Gwt.</CenterElement>,
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>Dia. Wt.</CenterElement>,
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>St. Wt.</CenterElement>,
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </CenterElement>
    ),
    dataIndex: 'nwt',
    key: 'nwt',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </CenterElement>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: '68px',
  },
  {
    title: <CenterElement>P. Wt.</CenterElement>,
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: '65px',
  },

  {
    title: <CenterElement>Wstg Wt.</CenterElement>,
    dataIndex: 'wastage',
    key: 'wastage',
    align: 'right',
    width: '72px',
  },

  {
    title: <CenterElement>Nt. with Wstg</CenterElement>,
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'right',
    width: '80px',
  },
  {
    title: <CenterElement>Making Amt.</CenterElement>,
    dataIndex: 'amount',
    key: 'amount',
    align: 'right',
    width: '70px',
  },
  {
    title: <CenterElement>Rate</CenterElement>,
    dataIndex: 'rate',
    key: 'rate',
    align: 'right',
    width: '70px',
  },

  // {
  //   title: <CenterElement>Dis. Amt.</CenterElement>,
  //   dataIndex: 'discountAmount',
  //   key: 'discountAmount',
  //   align: 'right',
  //   width: '70px',
  // },
  {
    title: <CenterElement>Net Amt.</CenterElement>,
    dataIndex: 'netAmount',
    key: 'netAmount',
    align: 'right',
    width: '75px',
  },
  {
    title: <CenterElement>Action</CenterElement>,
    key: 'action',
    dataIndex: 'action',
    width: '20px',
    fixed: 'right',
    align: 'center',
  },
];

export const SalesTableHeaderNew = [
  {
    title: 'S.N.',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: 27,
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'left',
    width: '170px',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
    width: '80px',
    render: (text) => text,
  },

  {
    title: <CenterElement>Purity</CenterElement>,
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '40px',
  },
  {
    title: <CenterElement>Gwt.</CenterElement>,
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>Dia. Wt.</CenterElement>,
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: <CenterElement>St. Wt.</CenterElement>,
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
    width: '60px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </CenterElement>
    ),
    dataIndex: 'nwt',
    key: 'nwt',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <CenterElement>
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </CenterElement>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: '68px',
  },
  {
    title: <CenterElement>P. Wt.</CenterElement>,
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: '65px',
  },

  {
    title: <CenterElement>Wstg Wt.</CenterElement>,
    dataIndex: 'wastage',
    key: 'wastage',
    align: 'right',
    width: '72px',
  },

  {
    title: <CenterElement>Nt. with Wstg</CenterElement>,
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'right',
    width: '80px',
  },
  {
    title: <CenterElement>Making Amt.</CenterElement>,
    dataIndex: 'amount',
    key: 'amount',
    align: 'right',
    width: '70px',
  },
  // {
  //   title: <CenterElement>Rate</CenterElement>,
  //   dataIndex: 'rate',
  //   key: 'rate',
  //   align: 'right',
  //   width: '70px',
  // },
  {
    title: <CenterElement>Rate</CenterElement>,
    dataIndex: 'ratePerPurity',
    key: 'ratePerPurity',
    align: 'right',
    width: '70px',
  },

  {
    title: <CenterElement>Sub Total</CenterElement>,
    dataIndex: 'subTotal',
    key: 'subTotal',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  {
    title: <CenterElement>Dis. Amt.</CenterElement>,
    dataIndex: 'discountAmount',
    key: 'discountAmount',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },
  {
    title: <CenterElement>Taxable Amt.</CenterElement>,
    dataIndex: 'taxableAmount',
    key: 'taxableAmount',
    align: 'right',
    width: '75px',
  },

  ...(userData?.isTaxApplicable
    ? [
        {
          title: <CenterElement>Tax Amt.</CenterElement>,
          dataIndex: 'taxAmount',
          key: 'taxAmount',
          align: 'right',
          width: '75px',
        },
      ]
    : []),

  ...(userData?.isVatApplicable
    ? [
        {
          title: <CenterElement>VAT Amt.</CenterElement>,
          dataIndex: 'vatAmount',
          key: 'vatAmount',
          align: 'right',
          width: '75px',
        },
      ]
    : []),

  // {
  //   title: <CenterElement>VAT Amt.</CenterElement>,
  //   dataIndex: 'vatAmount',
  //   key: 'vatAmount',
  //   align: 'right',
  //   width: '75px', // Set a small width to test wrapping
  // },

  {
    title: <CenterElement>Net Amt.</CenterElement>,
    dataIndex: 'netAmountWithTax',
    key: 'netAmountWithTax',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },
  {
    title: <CenterElement>Action</CenterElement>,
    key: 'action',
    dataIndex: 'action',
    width: '20px',
    fixed: 'right',
    align: 'center',
  },
];

export const DisableTransactionPurchaseTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'left',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'left',
    width: '200px',
  },
  {
    title: 'Purity',
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '60px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Gross Weight
      </div>
    ),
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Diamond Weight
      </div>
    ),
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
    width: '80px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Stone Weight
      </div>
    ),
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
    width: '70px',
  },

  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        {`Net Weight (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </div>
    ),
    dataIndex: 'nwt',
    key: 'nwt',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        {`Net Weight (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </div>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: '65px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Pure Weight
      </div>
    ),
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: '65px',
  },

  {
    title: (
      <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
        Wastage Weight
      </div>
    ),
    dataIndex: 'wastage',
    key: 'wastage',
    align: 'right',
    width: '75px', // Set a small width to test wrapping
  },

  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Net with Wastage
      </div>
    ),
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'right',
    width: '80px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Making Amount
      </div>
    ),
    dataIndex: 'amount',
    key: 'amount',
    align: 'right',
    width: '72px',
  },
  {
    title: `Rate`,
    dataIndex: 'rate',
    key: 'rate',
    align: 'right',
    width: '80px',
  },

  {
    title: (
      <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
        Net Amount
      </div>
    ),
    dataIndex: 'netAmount',
    key: 'netAmount',
    align: 'right',
    width: '70px', // Set a small width to test wrapping
  },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    width: '4%',
    align: 'center',
  },
];
export const IssueTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: '10px',
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'left',
    width: '190px',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'left',
    width: '100px',
  },
  {
    title: 'Purity',
    dataIndex: 'purity',
    key: 'purity',
    align: 'center',
    width: '50px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Gross Wt.
      </div>
    ),
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'center',
    width: '62px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Dia. Wt.
      </div>
    ),
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'center',
    width: '60px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Stone Wt.
      </div>
    ),
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'center',
    width: '60px',
  },

  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') || 'gm'})`}
      </div>
    ),
    dataIndex: 'nwt',
    key: 'nwt',
    align: 'center',
    width: '60px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        {`Nt. Wt. (${Cookies.get('primaryCalculationType') === 'lal' ? 'gm' : 'lal'})`}
      </div>
    ),
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'center',
    width: '65px',
  },
  {
    title: (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: 1.2,
        }}
      >
        Pure Wt.
      </div>
    ),
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'center',
    width: '65px',
  },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    width: 10,
    align: 'center',
  },
];
export const TransactionBillColumns = [
  {
    title: 'Item',
    dataIndex: 'itemName',
    key: 'itemName',
    align: 'center',
    width: '30%',
  },
  {
    title: 'Code',
    dataIndex: 'itemCode',
    key: 'itemCode',
    align: 'center',
    width: '20%',
  },
  {
    title: 'Purity',
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: '50px',
  },
  {
    title: 'G wt',
    dataIndex: 'grossWeight',
    key: 'grossWeight',
    align: 'center',
    width: '10%',
  },
  {
    title: 'D wt',
    dataIndex: 'diamondWeightCrt',
    key: 'diamondWeightCrt',
    align: 'center',
    width: '10%',
  },
  {
    title: 'S wt',
    dataIndex: 'stoneWeightGram',
    key: 'stoneWeightGram',
    align: 'center',
    width: '10%',
  },

  {
    title: 'N.wt',
    dataIndex: 'netAmount',
    key: 'netAmount',
    align: 'center',
    width: '10%',
  },
  {
    title: 'Wt in Tola',
    dataIndex: 'wtInTola',
    key: 'wtInTola',
    align: 'right',
    width: 60,
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: 'rate',
    align: 'center',
    width: '10%',
  },
  {
    title: 'Wastage',
    dataIndex: 'wastageWeight',
    key: 'wastageWeight',
    align: 'center',
    width: '10%',
  },
  {
    title: 'Net Wastage',
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'center',
    width: '10%',
  },
  {
    title: 'Pure Weight',
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
    width: 60,
  },
  {
    title: 'Making',
    dataIndex: 'makingAmount',
    key: 'makingAmount',
    align: 'center',
    width: '10%',
  },
  {
    title: 'Net Amount',
    dataIndex: 'netAmount',
    key: 'netAmount',
    align: 'center',
    width: '10%',
  },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    width: 10,
    align: 'center',
  },
];
export const TransactionReturnTableHeader = [
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'center',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
  },
  {
    title: 'G wt',
    dataIndex: 'grossWeight',
    key: 'grossWeight',
    align: 'center',
  },
  {
    title: 'D/s wt',
    dataIndex: 'dswt',
    key: 'dswt',
    align: 'center',
  },

  {
    title: 'N.wt',
    dataIndex: 'netWeight',
    key: 'netWeight',
    align: 'center',
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: 'rate',
    align: 'center',
  },
  {
    title: 'Wastage',
    dataIndex: 'wastageWeight',
    key: 'wastageWeight',
    align: 'center',
  },
  {
    title: 'Net With Wastage',
    dataIndex: 'netWithWastage',
    key: 'netWithWastage',
    align: 'center',
  },
  {
    title: 'Making',
    dataIndex: 'makingAmount',
    key: 'makingAmount',
    align: 'center',
  },
  {
    title: 'Amount',
    dataIndex: 'netAmount',
    key: 'netAmount',
    align: 'center',
  },

  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    width: 10,
    align: 'center',
  },
];
export const paymentVoucherTableHeader = [
  {
    title: 'Sno',
    dataIndex: 'sno',
    key: 'sno',
    align: 'center',
  },
  {
    title: 'Particular',
    dataIndex: 'particular',
    key: 'particular',
    align: 'center',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center',
  },
  {
    title: 'Remarks',
    dataIndex: 'remarks',
    key: 'remarks',
    align: 'center',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
  },
];
export const TransactionPurchaseCodeWindowTableHeader = [
  {
    title: 'S.no',
    dataIndex: 'sno',
    key: 'sno',
    align: 'center',
  },
  {
    title: 'Item D/s',
    dataIndex: 'itemDs',
    key: 'itemDs',
    align: 'center',
  },
  {
    title: 'Rate on',
    dataIndex: 'rateOn',
    key: 'rateOn',
    align: 'center',
  },
  {
    title: 'Pcs',
    dataIndex: 'pcs',
    key: 'pcs',
    align: 'center',
  },

  {
    title: 'unit',
    dataIndex: 'unit',
    key: 'unit',
    align: 'center',
  },
  {
    title: 'Weight',
    dataIndex: 'weight',
    key: 'weight',
    align: 'center',
  },
  {
    title: 'P.rate',
    dataIndex: 'pRate',
    key: 'pRate',
    align: 'center',
  },
  {
    title: 'Hc',
    dataIndex: 'hc',
    key: 'hc',
    align: 'center',
  },

  {
    title: 'Color',
    key: 'color',
    dataIndex: 'color',
    align: 'center',
  },
  {
    title: 'Clearity',
    key: 'clearity',
    dataIndex: 'clearity',
    align: 'center',
  },
  {
    title: 'Cut',
    key: 'cut',
    dataIndex: 'cut',
    align: 'center',
  },
  {
    title: 'Amount',
    key: 'amount',
    dataIndex: 'amount',
    align: 'center',
  },
  {
    title: 'Remark',
    key: 'remark',
    dataIndex: 'remark',
    align: 'center',
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 10,
  },
];

export const salesModalTableHeader = [
  {
    title: 'S.No',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    sorter: (a, b) => a.index - b.index,
  },
  {
    title: 'Item Name',
    dataIndex: 'itemName',
    key: 'itemName',
    align: 'center',
  },
  {
    title: 'Item Code',
    dataIndex: 'itemCode',
    key: 'itemCode',
    align: 'center',
  },
  {
    title: 'Purity',
    dataIndex: 'purity',
    key: 'purity',
    align: 'center',
  },
  {
    title: 'Gross Weight',
    dataIndex: 'grossWeight',
    key: 'grossWeight',
    align: 'center',
  },
];
export const MetalToCashTableHeader = [
  {
    title: 'S.N',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: 80,
    render: (text, record, index) => index + 1,
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    align: 'left',
  },
  {
    title: 'LedgerName',
    dataIndex: 'ledgerName',
    key: 'ledgerName',
    align: 'left',
    render: (text) => (
      <Tooltip title={text}>
        <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis ">
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: 'Bill No.',
    dataIndex: 'billNo',
    key: 'billNo',
    align: 'left',
  },

  {
    title: 'Cash',
    dataIndex: 'cash',
    key: 'cash',
    align: 'right',
    render: (value) => formatNumberWithComma(Number(value)),
  },
  {
    title: 'Metal',
    dataIndex: 'metal',
    key: 'metal',
    align: 'right',
  },
];
export const CashToMetalTableHeader = [
  {
    title: 'S.N',
    dataIndex: 'SN',
    key: 'SN',
    align: 'center',
    width: 80,
    render: (_, __, index) => index + 1,
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    align: 'left',
  },
  {
    title: 'LedgerName',
    dataIndex: 'ledgerName',
    key: 'ledgerName',
    align: 'left',
  },
  {
    title: 'Bill No.',
    dataIndex: 'billNo',
    key: 'billNo',
    align: 'left',
  },

  {
    title: 'Metal',
    dataIndex: 'metal',
    key: 'metal',
    align: 'right',
  },
  {
    title: 'Cash',
    dataIndex: 'cash',
    key: 'cash',
    align: 'right',
    render: (value) => formatNumberWithComma(Number(value)),
  },
];

export const PaymentVoucherListTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    key: 'S.N.',
    align: 'center',
    render: (_, __, index) => index + 1,
  },
  {
    title: 'Voucher Date',
    dataIndex: 'voucherDate',
    key: 'voucherDate',
    align: 'center',
  },
  {
    title: 'Paid From',
    dataIndex: 'payFrom',
    key: 'payFrom',
    align: 'left',
  },

  {
    title: 'Paid To',
    dataIndex: 'payTo',
    key: 'payTo',
    align: 'left',
  },
  {
    title: 'Voucher Number',
    dataIndex: 'voucherNo',
    key: 'voucherNo',
    align: 'center',
  },
  {
    title: 'Amount',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    align: 'right',
    render: (value) => formatNumberWithComma(value),
  },
  {
    title: 'Remarks',
    dataIndex: 'narration',
    key: 'narration',
    align: 'left',
    width: '20%',
  },
];
export const ReceiptListTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    key: 'S.N.',
    align: 'center',
    render: (_, __, index) => index + 1,
    width: 80,
  },
  {
    title: 'Voucher Date',
    dataIndex: 'voucherDate',
    key: 'voucherDate',
    align: 'center',
    width: 120,
  },
  {
    title: 'Received From',
    dataIndex: 'receiveFrom',
    key: 'receiveFrom',
    align: 'left',
    // render: (text) => (
    //   <Tooltip title={text}>
    //     <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis ">
    //       {text}
    //     </div>
    //   </Tooltip>
    // ),
  },
  {
    title: 'Received Into',
    dataIndex: 'receiveTo',
    key: 'receiveTo',
    align: 'left',
    // render: (text) => (
    //   <Tooltip title={text}>
    //     <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis ">
    //       {text}
    //     </div>
    //   </Tooltip>
    // ),
  },
  {
    title: 'Voucher Number',
    dataIndex: 'voucherNo',
    key: 'voucherNo',
    align: 'center',
    width: 120,
  },
  {
    title: 'Amount',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    align: 'right',
    width: 110,
    render: (value) => formatNumberWithComma(value),
  },
  {
    title: 'Remarks',
    dataIndex: 'narration',
    key: 'narration',
    align: 'left',
    width: 200,
  },
];
export const ContraListTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    key: 'S.N.',
    align: 'center',
    render: (_, __, index) => index + 1,
    width: 50,
  },
  {
    title: 'Voucher Date',
    dataIndex: 'voucherDate',
    key: 'voucherDate',
    align: 'center',
    width: 100,
  },
  {
    title: 'From',
    dataIndex: 'contraFrom',
    key: 'contraFrom',
    align: 'left',
    // render: (text) => (
    //   <Tooltip title={text}>
    //     <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis ">
    //       {text}
    //     </div>
    //   </Tooltip>
    // ),
  },
  {
    title: 'To',
    dataIndex: 'contraTo',
    key: 'contraTo',
    align: 'left',
    // render: (text) => (
    //   <Tooltip title={text}>
    //     <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis ">
    //       {text}
    //     </div>
    //   </Tooltip>
    // ),
  },

  {
    title: 'Voucher Number',
    dataIndex: 'voucherNo',
    key: 'voucherNo',
    align: 'center',
    width: 120,
  },
  {
    title: 'Amount',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    align: 'right',
    width: 100,
    render: (value) => formatNumberWithComma(value),
  },
  {
    title: 'Remarks',
    dataIndex: 'contraRemark',
    key: 'remarks',
    align: 'left',
    width: 200,
  },
];

export const MetalTransferTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    key: 'S.N.',
    align: 'center',
    render: (_, __, index) => index + 1,
    width: 50,
  },
  {
    title: 'Receive Date',
    dataIndex: 'receiveDate',
    key: 'receiveDate',
    align: 'center',
    width: 100,
  },
  {
    title: 'From',
    dataIndex: 'fromLedgerName',
    key: 'fromLedgerName',
    align: 'left',
    // render: (text) => (
    //   <Tooltip title={text}>
    //     <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis ">
    //       {text}
    //     </div>
    //   </Tooltip>
    // ),
  },
  {
    title: 'To',
    dataIndex: 'toLedgerName',
    key: 'toLedgerName',
    align: 'left',
    // render: (text) => (
    //   <Tooltip title={text}>
    //     <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis ">
    //       {text}
    //     </div>
    //   </Tooltip>
    // ),
  },

  {
    title: 'Bill Number',
    dataIndex: 'billNo',
    key: 'billNo',
    align: 'center',
    width: 120,
  },
  {
    title: 'Metal',
    dataIndex: 'metal',
    key: 'metal',
    align: 'right',
    width: 100,
  },
  {
    title: 'Remarks',
    dataIndex: 'metalRemark',
    key: 'remarks',
    align: 'left',
    width: 200,
  },
];
export const JournalListTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    key: 'S.N.',
    align: 'center',
    render: (_, __, index) => index + 1,
    width: 50,
  },
  {
    title: 'Voucher Date',
    dataIndex: 'voucherDate',
    key: 'Voucher Date',
    align: 'center',
    width: 120,
  },
  {
    title: 'From',
    dataIndex: 'payFrom',
    key: 'Pay From',
    align: 'left',
    width: 200,
    render: (text) => {
      const accounts = text?.split(',').map((acc) => acc.trim());
      const displayed = accounts?.slice(0, 2).join(', ');

      return (
        <Tooltip title={text}>
          <div className="flex">
            <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis">
              {displayed}
            </div>
          </div>
        </Tooltip>
      );
    },
  },
  {
    title: 'To',
    dataIndex: 'payTo',
    key: 'Pay To',
    align: 'left',
    width: 200,
    render: (text) => {
      const accounts = text?.split(',').map((acc) => acc.trim());
      const displayed = accounts?.slice(0, 2).join(', ');

      return (
        <Tooltip title={text}>
          <div className="flex">
            <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis">
              {displayed}
            </div>
          </div>
        </Tooltip>
      );
    },
  },

  {
    title: 'Voucher Number',
    dataIndex: 'voucherNo',
    key: 'Voucher Number',
    align: 'center',
    width: 100,
  },
  {
    title: 'Amount',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    align: 'right',
    width: 100,
    render: (value) => formatNumberWithComma(value),
  },
  {
    title: 'Long Narration',
    dataIndex: 'narration',
    key: 'Remarks',
    align: 'left',
    width: 200,
    render: (text) => (
      <Tooltip
        title={text}
        color="green"
        styles={{
          body: {
            padding: '20px 18px',
            backgroundColor: '#bef9bfef',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'green',
            fontSize: '14px',
            borderTopLeftRadius: '24px',
            borderBottomRightRadius: '24px',
          },
        }}
      >
        <div className="tw-whitespace-nowrap tw-max-w-64 tw-overflow-hidden tw-text-ellipsis ">
          {text}
        </div>
      </Tooltip>
    ),
  },
];
export const PartyLoanDetailsTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    key: 'S.N.',
    align: 'center',
    render: (_, __, index) => index + 1, // Dynamic SN
  },
  {
    title: 'Ledger Name',
    dataIndex: 'ledgerName',
    key: 'ledgerName',
    align: 'center',
  },
  {
    title: 'Id Number',
    dataIndex: 'idNumber',
    key: 'idType',
    align: 'center',
  },
  {
    title: 'Id Type',
    dataIndex: 'idType',
    key: 'idType',
    align: 'center',
  },
  {
    title: 'Interest Rate',
    dataIndex: 'interestRate',
    key: 'interestRate',
    align: 'center',
  },
];

export const LoanDealTableHeader = [
  {
    title: 'SN',
    dataIndex: 'S.N.',
    key: 'S.N.',
    align: 'center',
    render: (_, __, index) => index + 1, // Dynamic SN
  },
  {
    title: 'Ledger Name',
    dataIndex: 'ledgerName',
    key: 'ledgerName',
    align: 'center',
  },
  {
    title: 'Id Number',
    dataIndex: 'idNumber',
    key: 'idType',
    align: 'center',
  },
  {
    title: 'Id Type',
    dataIndex: 'idType',
    key: 'idType',
    align: 'center',
  },
  {
    title: 'Interest Rate',
    dataIndex: 'interestRate',
    key: 'interestRate',
    align: 'center',
  },
];
export const DayBookReportTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    key: 'S.N.',
    align: 'left',
    width: 45,
  },
  {
    title: 'Party Name',
    dataIndex: 'Party Name',
    key: 'Party Name',
    align: 'left',
  },
  {
    title: 'Bill Number',
    dataIndex: 'Bill No.',
    key: 'Bill No.',
    align: 'center',
  },
  {
    title: 'Ref Number',
    dataIndex: ' Ref. No.',
    key: ' Ref. No.',
    align: 'left',
  },
  {
    title: 'Amount',
    dataIndex: 'Amount',
    key: 'Amount',
    align: 'right',
  },
];
export const DayBookReportVoucherTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S N',
    key: 'S N',
    align: 'left',
    width: '45px',
    render: (_, __, index) => index + 1, // Dynamic SN
  },
  {
    title: 'Voucher Type',
    dataIndex: 'Voucher Type',
    key: 'Voucher Type',
    align: 'left',
  },
  {
    title: 'Vch/Bill No',
    dataIndex: 'Vch/Bill No',
    key: 'Vch/Bill No',
    align: 'left',
    width: 80,
  },
  {
    title: 'Account',
    dataIndex: 'Account',
    key: 'Account',
    align: 'left',
  },
  {
    title: 'Debit',
    dataIndex: 'Debit (Rs.)',
    key: 'Debit (Rs.)',
    align: 'right',
  },
  {
    title: 'Credit',
    dataIndex: 'Credit (Rs.)',
    key: 'Credit (Rs.)',
    align: 'right',
  },
];
export const DayBookReportCashBankTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'S.N.',
    key: 'S.N.',
    align: 'left',
    width: '45px',
  },
  {
    title: 'Ledger Name',
    dataIndex: 'ledgerName',
    key: 'ledgerName',
    align: 'left',
  },
  {
    title: 'Opening Balance',
    dataIndex: 'openingBalance',
    key: 'openingBalance',
    align: 'right',
  },

  {
    title: 'Debit',
    dataIndex: 'drAmount',
    key: 'drAmount',
    align: 'right',
  },
  {
    title: 'Credit',
    dataIndex: 'crAmount',
    key: 'crAmount',
    align: 'right',
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    key: 'balance',
    align: 'right',
  },
];

//admin dashboard table headers
export const customerTableHeader = [
  {
    title: 'Full Name',
    dataIndex: 'name',
    key: 'name',
    align: 'center',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    align: 'center',
  },
  {
    title: 'Mobile',
    dataIndex: 'mobile',
    key: 'mobile',
    align: 'center',
  },

  {
    title: 'Subscription',
    dataIndex: 'subscription',
    key: 'subscription',
    align: 'center',
  },
];

export const adminUserHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    sorter: (a, b) => a.index - b.index,
    width: 50,
  },
  {
    title: 'User Name',
    dataIndex: 'username',
    key: 'username',
    align: 'left',
  },
  {
    title: 'Full Name',
    dataIndex: 'name',
    key: 'name',
    align: 'left',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    align: 'left',
  },
  {
    title: 'Mobile',
    dataIndex: 'mobile',
    key: 'mobile',
    align: 'left',
  },

  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    width: 120,
  },
];

export const RoleHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
  },
  {
    title: 'Company',
    dataIndex: 'companyName',
    key: 'companyName',
    align: 'left',
  },
  {
    title: 'Branch',
    dataIndex: 'branchName',
    key: 'branchName',
    align: 'left',
  },

  {
    title: 'Role',
    dataIndex: 'name',
    key: 'name',
    align: 'left',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    width: 100,
  },
];

export const MenuHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
  },
  {
    title: 'Menu Name',
    dataIndex: 'menuName',
    key: 'menuName',
    align: 'center',
  },
  {
    title: 'List Path',
    dataIndex: 'listUrl',
    key: 'listUrl',
    align: 'center',
  },

  {
    title: 'Create Path',
    dataIndex: 'createUrl',
    key: 'createUrl',
    align: 'center',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
  },
];

export const PurchaseDetailsReportTableHeader = [
  {
    title: 'S.No',
    dataIndex: 'S.N',
    key: 'S.N',
    align: 'center',
    fixed: 'left',
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    align: 'center',
  },
  {
    title: 'Voucher No',
    dataIndex: 'voucherNo',
    key: 'voucherNo',
    align: 'center',
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    align: 'center',
  },
  {
    title: 'Item',
    dataIndex: 'item',
    key: 'item',
    align: 'center',
  },
  {
    title: 'code',
    dataIndex: 'code',
    key: 'code',
    align: 'center',
  },
  {
    title: 'Purity',
    dataIndex: 'purity',
    key: 'purity',
    align: 'center',
  },
  {
    title: 'Gwt',
    dataIndex: 'gwt',
    key: 'gwt',
    align: 'center',
  },
  {
    title: 'Dia Pcs',
    dataIndex: 'diaPcs',
    key: 'diaPcs',
    align: 'center',
  },
  {
    title: 'Dia Wt',
    dataIndex: 'diaWt',
    key: 'diaWt',
    align: 'center',
  },
  {
    title: 'Dia Amt',
    dataIndex: 'diaAmt',
    key: 'diaAmt',
    align: 'center',
  },
  {
    title: 'S.Pcs',
    dataIndex: 'sPcs',
    key: 'sPcs',
    align: 'center',
  },
  {
    title: 'S.Wt',
    dataIndex: 'sWt',
    key: 'sWt',
    align: 'center',
  },
  {
    title: 'S.Amt',
    dataIndex: 'sAmt',
    key: 'sAmt',
    align: 'center',
  },
  {
    title: 'N.wt',
    dataIndex: 'nwt',
    key: 'nWt',
    align: 'center',
  },
  {
    title: 'Wast. Wt',
    dataIndex: 'wastWt',
    key: 'wastWt',
    align: 'center',
  },
  {
    title: 'M. Amt',
    dataIndex: 'mAmt',
    key: 'mAmt',
    align: 'center',
  },
  {
    title: 'Extra',
    dataIndex: 'extra',
    key: 'extra',
    align: 'center',
  },
  {
    title: 'Net Amount',
    dataIndex: 'netAmount',
    key: 'netAmount',
    align: 'center',
  },
];
export const SalesOrderDataTableHeader = [
  {
    title: 'S.No',
    dataIndex: 'SN',
    key: 'SN',
    render: (text, record, index) => index + 1,
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    onHeaderCell: () => ({ style: { textAlign: 'center' } }),

    align: 'center',
    width: '40%',
  },
  {
    title: 'Item Name',
    dataIndex: 'itemName',
    key: 'itemName',
    align: 'center',
  },
  {
    title: 'Item Code',
    dataIndex: 'itemCode',
    key: 'itemCode',
    align: 'center',
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: 'rate',
    onHeaderCell: () => ({ style: { textAlign: 'center' } }),

    align: 'right',
  },
  {
    title: 'Purity',
    dataIndex: 'purity',
    key: 'purity',
    onHeaderCell: () => ({ style: { textAlign: 'center' } }),

    align: 'right',
  },

  {
    title: 'Gross Weight',
    dataIndex: 'grossWeight',
    key: 'grossWeight',
    onHeaderCell: () => ({ style: { textAlign: 'center' } }),

    align: 'right',
    width: '10%',
  },
  {
    title: 'Net Amount',
    dataIndex: 'netAmount',
    key: 'netAmount',
    onHeaderCell: () => ({ style: { textAlign: 'center' } }),

    align: 'right',
    width: '10%',
  },
];

// roles menu mapping table header
export const RoleMenuHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
  },
  {
    title: 'Company',
    dataIndex: 'company',
    key: 'company',
    align: 'left',
  },
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
    align: 'left',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    align: 'left',
  },
  {
    title: 'Menu',
    dataIndex: 'menus',
    key: 'menus',
    align: 'center',
    width: 300,
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    width: 100,
  },
];
export const printerCssHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
  },

  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
    align: 'left',
  },

  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    width: 100,
  },
];

export const RoleUserMappingHeader = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
  },
  {
    title: 'Username',
    dataIndex: 'username',
    key: 'username',
    align: 'left',
  },
  {
    title: 'Mobile',
    dataIndex: 'mobileNumber',
    key: 'mobileNumber',
    align: 'left',
  },
  {
    title: 'Company',
    dataIndex: 'company',
    key: 'company',
    align: 'left',
  },
  {
    title: 'Branch',
    dataIndex: 'branchName',
    key: 'branchName',
    align: 'left',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    align: 'left',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    width: 100,
  },
];

export const purchaseTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },
  {
    title: 'Purchase Date',
    dataIndex: 'purchaseDate',
    key: 'purchaseDate',
    align: 'center',
    width: 104,
  },
  {
    title: 'Bill No.',
    dataIndex: 'billNo',
    key: 'billNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Ref. No.',
    dataIndex: 'refNo',
    key: 'refNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center',
    width: 70,
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];

export const salesOrderSkeletonTableHeader = [
  {
    title: 'S N',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },
  {
    title: 'Order Date',
    dataIndex: 'salesOrderDate',
    key: 'salesOrderDate',
    align: 'center',
    width: 104,
  },
  {
    title: 'Bill No.',
    dataIndex: 'billNo',
    key: 'billNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Ref. No.',
    dataIndex: 'refNo',
    key: 'refNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Agent Name',
    dataIndex: 'agentName',
    key: 'agentName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center',
    width: 70,
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];

export const salesSkeletonTableHeader = [
  {
    title: 'S N',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },
  {
    title: 'Sales Date',
    dataIndex: 'salesDate',
    key: 'salesDate',
    align: 'center',
    width: 104,
  },
  {
    title: 'Bill No.',
    dataIndex: 'billNo',
    key: 'billNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Ref. No.',
    dataIndex: 'refNo',
    key: 'refNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Agent Name',
    dataIndex: 'agentName',
    key: 'agentName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Purchase',
    dataIndex: 'purchase',
    key: 'purchase',
    align: 'center',
    width: 112,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center',
    width: 70,
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];

export const salesReturnSkeletonTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },
  {
    title: 'Return Date',
    dataIndex: 'returnDate',
    key: 'returnDate',
    align: 'center',
    width: 104,
  },
  {
    title: 'Bill No.',
    dataIndex: 'billNo',
    key: 'billNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Ref. No.',
    dataIndex: 'refNo',
    key: 'refNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center',
    width: 70,
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];

export const purchaseReturnSkeletonTableHeader = [
  {
    title: 'S N',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },
  {
    title: 'Opening Date',
    dataIndex: 'openingDate',
    key: 'openingDate',
    align: 'center',
    width: 104,
  },
  {
    title: 'Bill Number.',
    dataIndex: 'billNumber',
    key: 'billNumber',
    align: 'center',
    width: 80,
  },
  {
    title: 'Reference Number.',
    dataIndex: 'refNumber',
    key: 'refNumber',
    align: 'center',
    width: 80,
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center',
    width: 70,
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];

export const openingStockSkeletonTableHeader = [
  {
    title: 'S N',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },
  {
    title: 'Opening Date',
    dataIndex: 'openingDate',
    key: 'openingDate',
    align: 'center',
    width: 104,
  },
  {
    title: 'Bill Number.',
    dataIndex: 'billNumber',
    key: 'billNumber',
    align: 'center',
    width: 80,
  },
  {
    title: 'Reference Number.',
    dataIndex: 'refNumber',
    key: 'refNumber',
    align: 'center',
    width: 80,
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center',
    width: 70,
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];

export const issueSkeletonTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },
  {
    title: 'Issue Date',
    dataIndex: 'issueDate',
    key: 'issueDate',
    align: 'center',
    width: 104,
  },
  {
    title: 'Bill No..',
    dataIndex: 'billNo',
    key: 'billNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Ref. No.',
    dataIndex: 'refNo.',
    key: 'refNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Pure Weight',
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'center',
    width: 70,
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];

export const receiveSkeletonTableHeader = [
  {
    title: 'S.N.',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },
  {
    title: 'Receive Date',
    dataIndex: 'receiveDate',
    key: 'receiveDate',
    align: 'center',
    width: 104,
  },
  {
    title: 'Bill No..',
    dataIndex: 'billNo',
    key: 'billNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Ref. No.',
    dataIndex: 'refNo.',
    key: 'refNo',
    align: 'center',
    width: 80,
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
    align: 'center',
    width: 112,
  },
  {
    title: 'Pure Weight',
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'center',
    width: 70,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center',
    width: 70,
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'action',
    align: 'center',
    width: 90,
  },
];

export const stockList = [
  {
    title: 'S.N.',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },
  {
    title: 'Category',
    dataIndex: 'subGroupName',
    key: 'subGroupName',
    align: 'left',
    width: 200,
  },
  {
    title: 'Item Name',
    dataIndex: 'itemName',
    key: 'itemName',
    align: 'left',
    width: 300,
  },
  {
    title: 'Set Pcs',
    dataIndex: 'setPcs',
    key: 'setPcs',
    align: 'right',
  },
  {
    title: 'Gross Weight',
    dataIndex: 'grossWeight',
    key: 'grossWeight',
    align: 'right',
  },
  {
    title: 'Diamond Weight',
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
  },
  {
    title: 'Stone Weight',
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
  },
  {
    title: 'Net Weight',
    dataIndex: 'netWeight',
    key: 'netWeight',
    align: 'right',
  },
  {
    title: 'Pure Weight',
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
  },
  // {
  //   title: 'Net With Wastage',
  //   dataIndex: 'netWithWastage',
  //   key: 'netWithWastage',
  //   align: 'center',
  // },
];

export const stockCode = [
  {
    title: 'S.N.',
    dataIndex: 'sn',
    key: 'sn',
    align: 'center',
    width: 50,
  },

  {
    title: 'Date',
    dataIndex: 'changeAt',
    key: 'changeAt',
    align: 'center',
    width: 85,
  },
  {
    title: 'Item Code',
    dataIndex: 'itemCode',
    key: 'itemCode',
    align: 'center',
  },
  {
    title: 'Ref. Item Code',
    dataIndex: 'referenceItemCode',
    key: 'referenceItemCode',
    align: 'center',
  },
  {
    title: 'Karigar Name',
    dataIndex: 'karigarName',
    key: 'karigarName',
    align: 'center',
  },
  {
    title: 'Purity',
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
  },
  // {
  //   title: 'Set Pcs',
  //   dataIndex: 'setPcs',
  //   key: 'setPcs',
  //   align: 'right',
  // },
  {
    title: 'Gross Weight',
    dataIndex: 'grossWeight',
    key: 'grossWeight',
    align: 'right',
  },
  {
    title: 'Diamond Weight',
    dataIndex: 'diamondWeight',
    key: 'diamondWeight',
    align: 'right',
  },
  {
    title: 'Stone Weight',
    dataIndex: 'stoneWeight',
    key: 'stoneWeight',
    align: 'right',
  },
  {
    title: 'Net Weight',
    dataIndex: 'netWeight',
    key: 'netWeight',
    align: 'right',
  },
  {
    title: 'Pure Weight',
    dataIndex: 'pureWeight',
    key: 'pureWeight',
    align: 'right',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    width: 100,
  },
];

export const SalesBillSummaryHeader = [
  {
    title: 'SN',
    dataIndex: 's_n',
    key: 's_n',
    align: 'center',
    width: 50,
    render: (_, __, index) => index + 1,
  },
  {
    title: 'Bill No.',
    dataIndex: 'bill_no',
    key: 'bill_no',
    align: 'left',
    width: 90,
  },
  {
    title: 'Ref. Bill No.',
    dataIndex: 'ref_bill_no',
    key: 'ref_bill_no',
    align: 'left',
    width: 90,
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    align: 'center',
    width: 90,
  },
  {
    title: 'Customer Name',
    dataIndex: 'customer_name',
    key: 'customer_name',
    align: 'left',
    width: 160,
  },
  {
    title: 'Customer Address',
    dataIndex: 'customer_address',
    key: 'customer_address',
    align: 'left',
    width: 160,
  },
  {
    title: 'Contact No.',
    dataIndex: 'contact_no',
    key: 'contact_no',
    align: 'left',
    width: 100,
  },
  {
    title: 'Purity',
    dataIndex: 'purity',
    key: 'purity',
    align: 'right',
    width: 70,
  },
  {
    title: 'Net Wt.',
    dataIndex: 'net_wt',
    key: 'net_wt',
    align: 'right',
    width: 80,
  },
  {
    title: 'Gold Amt.',
    dataIndex: 'gold_amt',
    key: 'gold_amt',
    align: 'right',
    width: 100,
  },
  {
    title: 'Wastage',
    dataIndex: 'wastage',
    key: 'wastage',
    align: 'right',
    width: 80,
  },
  {
    title: 'Wastage Amt.',
    dataIndex: 'wastage_amt',
    key: 'wastage_amt',
    align: 'right',
    width: 90,
  },
  {
    title: 'Stone Amt.',
    dataIndex: 'stone_amt',
    key: 'stone_amt',
    align: 'right',
    width: 90,
  },
  {
    title: 'Making Chr.',
    dataIndex: 'making_chr',
    key: 'making_chr',
    align: 'right',
    width: 100,
  },
  {
    title: 'Taxable Amount',
    dataIndex: 'taxable_amount',
    key: 'taxable_amount',
    align: 'right',
    width: 110,
  },
  {
    title: 'Tax Amt.',
    dataIndex: 'tax_amount',
    key: 'tax_amount',
    align: 'right',
    width: 90,
  },
  {
    title: 'Vatable Amt.',
    dataIndex: 'vatable_amount',
    key: 'vatable_amount',
    align: 'right',
    width: 100,
  },
  {
    title: 'Vat Amt.',
    dataIndex: 'vat_amount',
    key: 'vat_amount',
    align: 'right',
    width: 90,
  },
  {
    title: 'Total Amt.',
    dataIndex: 'total_amt',
    key: 'total_amt',
    align: 'right',
    width: 100,
  },
  {
    title: 'Dia. Amt.',
    dataIndex: 'dia_amt',
    key: 'dia_amt',
    align: 'right',
    width: 90,
  },
  {
    title: 'Diamond',
    dataIndex: 'diamond',
    key: 'diamond',
    align: 'right',
    width: 80,
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: 'rate',
    align: 'right',
    width: 80,
  },
];

export const stockModalColumns = [
  {
    title: 'Item Code',
    dataIndex: 'show_item_code',
    key: 'show_item_code',
    align: 'left',
    width: 120,
    render: (text) => <span>{text ?? 'N/A'}</span>,
  },
  {
    title: 'Reference Code',
    dataIndex: 'reference_code',
    key: 'reference_code',
    align: 'left',
    width: 120,
    render: (text) => <span>{text ?? ''}</span>,
  },
  {
    title: 'Order Code',
    dataIndex: 'order_code',
    key: 'order_code',
    align: 'left',
    width: 110,
    render: (text) => <span>{text ?? ''}</span>,
  },
  {
    title: 'Set/Pcs',
    dataIndex: 'set_pcs',
    key: 'set_pcs',
    align: 'right',
    width: 80,
    render: (text) => (Number(text) === 0 ? '' : text),
  },
  {
    title: 'Gross Wt',
    dataIndex: 'gross_weight',
    key: 'gross_weight',
    align: 'right',
    width: 90,
    render: (text) => (Number(text) === 0 ? '' : text),
  },
  {
    title: 'Diamond Wt',
    dataIndex: 'diamond_weight',
    key: 'diamond_weight',
    align: 'right',
    width: 100,
    render: (text) => (Number(text) === 0 ? '' : text),
  },
  {
    title: 'Stone Wt',
    dataIndex: 'stone_weight',
    key: 'stone_weight',
    align: 'right',
    width: 90,
    render: (text) => (Number(text) === 0 ? '' : text),
  },
  {
    title: 'Net Wt',
    dataIndex: 'net_weight',
    key: 'net_weight',
    align: 'right',
    width: 80,
    render: (text) => (Number(text) === 0 ? '' : text),
  },
  {
    title: 'Pure Wt',
    dataIndex: 'pure_weight',
    key: 'pure_weight',
    align: 'right',
    width: 80,
    render: (text) => (Number(text) === 0 ? '' : text),
  },
];

export const IssueListHeader = [
  {
    title: 'SN',
    dataIndex: 'sn',
    key: 'sn',
    render: (_, __, index) => index + 1,
  },
  // {
  //   title: 'Is Receive',
  //   dataIndex: 'isReceive',
  //   key: 'isReceive',
  //   render: (val) => (val ? 'Yes' : 'No'),
  // },
  // {
  //   title: 'Purchase ID',
  //   dataIndex: 'purchaseId',
  //   key: 'purchaseId',
  // },
  {
    title: 'Date',
    dataIndex: 'issueDate',
    key: 'issueDate',
  },
  {
    title: 'Bill No',
    dataIndex: 'billNo',
    key: 'billNo',
  },
  {
    title: 'Ref No',
    dataIndex: 'refNo',
    key: 'refNo',
  },
  {
    title: 'Party Name',
    dataIndex: 'partyName',
    key: 'partyName',
  },
  {
    title: 'Store',
    dataIndex: 'storeName',
    key: 'storeName',
  },
  {
    title: 'Pure Weight',
    dataIndex: 'pureWeight',
    key: 'pureWeight',
  },
];

export const DayStockLedgerReportTableHeader = [
  {
    title: 'Particular',
    dataIndex: 'particular',
    key: 'particular',
    align: 'left',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    align: 'right',
    width: 90,
  },
  {
    title: 'Total Weight',
    dataIndex: 'total_weight',
    key: 'total_weight',
    align: 'right',
    width: 120,
  },
  {
    title: '24K Converted',
    dataIndex: 'converted_24k',
    key: 'converted_24k',
    align: 'right',
    width: 130,
  },
  {
    title: 'Stone Amount',
    dataIndex: 'stone_amount',
    key: 'stone_amount',
    align: 'right',
    width: 130,
  },
  {
    title: 'Diamond Amount',
    dataIndex: 'diamond_amount',
    key: 'diamond_amount',
    align: 'right',
    width: 140,
  },
  {
    title: 'Wages',
    dataIndex: 'wages',
    key: 'wages',
    align: 'right',
    width: 120,
  },
];
